import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/workers/recommendUWorker/fetchTeamMembers/REQUEST';
export const SUCCESS = '@app/workers/recommendUWorker/fetchTeamMembers/SUCCESS';
export const FAILURE = '@app/workers/recommendUWorker/fetchTeamMembers/FAILURE';
export const CLEAR = '@app/workers/recommendUWorker/fetchTeamMembers/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    error: '',
    items: []
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                break;
            case SUCCESS:
                draft.loading = false;
                draft.items = payload.data;
                break;
            case FAILURE:
                draft.loading = false;
                draft.error = payload;
                break;
            case CLEAR:
                draft.loading = false;
                draft.items = [];
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.get(`/companies/users/${payload}`);
            yield put(actions.success(response.data));
        } catch (e) {
            yield put(actions.failure(errorMessageGenerator(e)));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
